import Blog from "../../layouts/Blog";
import "../../styles/Blog.css"
import hljs from 'highlight.js';
import 'highlight.js/styles/dark.css';
import LinkedText from "../../components/LinkedText";
import {useEffect} from "react";
import {getRandomColor} from "../../utils/GetRandomColor";

import TheInvitation from "../../components/blog/googleFoobarChallange/TheInvitation";
import ReId from "../../components/blog/googleFoobarChallange/ReId";
import HeyIAlreadyDidThat from "../../components/blog/googleFoobarChallange/HeyIAlreadyDidThat";
import ElevatorMaintenance from "../../components/blog/googleFoobarChallange/ElevatorMaintenance";
import PrepareTheBunniesEscape from "../../components/blog/googleFoobarChallange/PrepareTheBunniesEscape";
import DoomsdayFuel from "../../components/blog/googleFoobarChallange/DoomsdayFuel";
import DontGetVolunteered from "../../components/blog/googleFoobarChallange/DontGetVolunteered";
import FreeTheBunnyWorkers from "../../components/blog/googleFoobarChallange/FreeTheBunnyWorkers";
import BringingAGunToATrainerFight from "../../components/blog/googleFoobarChallange/BringingAGunToATrainerFight";
import ExpandingNebula from "../../components/blog/googleFoobarChallange/ExpandingNebula";
import IconText from "../../components/IconText";

export default function GoogleFoobarChallenge() {
    useEffect(() => {
        hljs.highlightAll();
    }, []);

    const imageStyle = {
        border: `5px solid ${getRandomColor()}`,
    };

    const lottieStyle = {
        border: `5px solid ${getRandomColor()}`,
    };

    const rightContent = (
        <div>
            <h1>
                <IconText text={"Google Foobar Challenge Solutions with Animations"}
                          bgColor={true}/>
            </h1>
            <div className={"blog-abstract"}>
                <p>
                    Recently, I was invited to Google's secret coding interview, Foobar Challenge. From Markov
                    chains to
                    cellular automata, this challenge was the hardest and most fun coding experience I have ever
                    had. I have
                    decided to share my solutions with the animations I have made for questions, which make them
                    easier to
                    understand.
                </p>
                <p>TL;DR? Check the <LinkedText href={"https://github.com/mpospirit/google_foobar_challange"}
                                                text={"GitHub repository"}></LinkedText>.</p>
            </div>


            <TheInvitation/>

            <ReId/>

            <HeyIAlreadyDidThat/>

            <ElevatorMaintenance/>

            <PrepareTheBunniesEscape/>

            <DoomsdayFuel/>

            <DontGetVolunteered/>

            <FreeTheBunnyWorkers/>

            <BringingAGunToATrainerFight/>
            
            <ExpandingNebula/>

        </div>
    )

    return (
        <div className="google-foobar-challange-page">
            <Blog rightContent={rightContent}/>
        </div>
    )
}
